import { render, staticRenderFns } from "./MRSummary.vue?vue&type=template&id=323fe010"
import script from "./MRSummary.vue?vue&type=script&lang=ts"
export * from "./MRSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports